var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    {
      on: { "tab-click": _vm.handleClick },
      model: {
        value: _vm.activeName,
        callback: function($$v) {
          _vm.activeName = $$v
        },
        expression: "activeName"
      }
    },
    [
      _c(
        "el-tab-pane",
        { attrs: { label: "商品分类", name: "goodsCat" } },
        [
          _vm.activeName == "goodsCat"
            ? _c("swb-mercht-tpl-role-goods-cat", {
                attrs: { roleId: _vm.roleId, readOnly: _vm.readOnly }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tab-pane",
        { attrs: { label: "服务分类", name: "servcCat" } },
        [
          _vm.activeName == "servcCat"
            ? _c("swb-mercht-tpl-role-servc-cat", {
                attrs: { roleId: _vm.roleId, readOnly: _vm.readOnly }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30f330c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30f330c4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/authx/MerchtBizPermScopeBusinessSet.vue
// module id = 2212
// module chunks = 1